import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiToolbarComponent {
    @HostBinding('class') string = 'eui-toolbar';

    constructor(
        public asService: UxAppShellService,
    ) {}
}
